import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: require("@/views/Reserve/Template.vue").default,
    children: [
      {
        path: "",
        component: require("@/views/Reserve/Home.vue").default,
      },
      {
        path: "survey",
        // component: require("@/views/Reserve/Survey.vue").default,
        component: require("@/views/Survey/Survey.vue").default,
      },
      {
        path: "privacy",
        component: require("@/views/Reserve/Privacy.vue").default,
      },
      {
        path: "sitemap",
        component: require("@/views/Reserve/Sitemap.vue").default,
      },
      {
        path: "personal",
        component: require("@/views/Reserve/Personal.vue").default,
      },
      {
        path: "itemCheck",
        component: require("@/views/Reserve/ItemCheck.vue").default,
      },
      {
        path: "itemConfirm",
        component: require("@/views/Reserve/ItemConfirm.vue").default,
      },
      {
        path: "questionnaire/1",
        component: require("@/views/Reserve/Questionnaire/Q1.vue").default,
      },
      {
        path: "questionnaire/2",
        component: require("@/views/Reserve/Questionnaire/Q2.vue").default,
      },
      {
        path: "questionnaire/3",
        component: require("@/views/Reserve/Questionnaire/Q3.vue").default,
      },
      {
        path: "questionnaire/4",
        component: require("@/views/Reserve/Questionnaire/Q4.vue").default,
      },
      {
        path: "questionnaire/5",
        component: require("@/views/Reserve/Questionnaire/Q5.vue").default,
      },
      {
        path: "section",
        component: require("@/views/Reserve/Section.vue").default,
      },
      {
        path: "confirm",
        component: require("@/views/Reserve/Confirm.vue").default,
      },
    ],
  },
  {
    path: "/quick",
    component: require("@/views/Quick/Template.vue").default,
    children: [
      {
        path: "",
        component: require("@/views/Quick/Home.vue").default,
      },
      {
        path: "confirm",
        component: require("@/views/Quick/Confirm.vue").default,
      },
      {
        path: "itemCheck",
        component: require("@/views/Quick/ItemCheck.vue").default,
      },
      {
        path: "itemConfirm",
        component: require("@/views/Quick/ItemConfirm.vue").default,
      },
      {
        path: "section",
        component: require("@/views/Quick/Section.vue").default,
      },
    ],
  },
  {
    path: "/temp",
    component: require("@/views/Survey/Template.vue").default,
    children: [
      {
        path: "",
        component: require("@/views/Survey/Survey.vue").default,
      },
    ],
  },
  {
    path: "/dashboard",
    component: require("@/views/Dashboard/Login.vue").default,
  },
  {
    path: "/dashboard/activate-password",
    component: require("@/views/Dashboard/ActivatePassword.vue").default,
  },
  {
    path: "/dashboard",
    component: require("@/views/Dashboard/Template.vue").default,
    children: [
      {
        path: "main",
        name: "main",
        component: require("@/views/Dashboard/Main.vue").default,
      },
      {
        path: "people",
        name: "people",
        component: require("@/views/Dashboard/People.vue").default,
      },
      {
        path: "section",
        name: "section",
        component: require("@/views/Dashboard/Section.vue").default,
      },
      // {
      //   path: "print",
      //   name: "print",
      //   component: require("@/views/Dashboard/Print.vue").default,
      // },
      {
        path: "importList",
        name: "importList",
        component: require("@/views/Dashboard/ImportList.vue").default,
      },
      {
        path: "importReport",
        name: "importReport",
        component: require("@/views/Dashboard/ImportReport.vue").default,
      },
      {
        path: "checkin",
        name: "checkin",
        component: require("@/views/Dashboard/Checkin.vue").default,
      },
      {
        path: "checkinReport",
        name: "checkinReport",
        component: require("@/views/Dashboard/CheckinReport.vue").default,
      },
      {
        path: "inspection",
        name: "inspection",
        component: require("@/views/Dashboard/Inspection.vue").default,
      },
      {
        path: "invite",
        name: "invite",
        component: require("@/views/Dashboard/Invite.vue").default,
      },
      {
        path: "account",
        name: "account",
        component: require("@/views/Dashboard/Account.vue").default,
      },
      {
        path: "systemLog",
        name: "systemLog",
        component: require("@/views/Dashboard/SystemLog.vue").default,
      },
      {
        path: "reservationLog",
        name: "reservationLog",
        component: require("@/views/Dashboard/ReservationLog.vue").default,
      },
      {
        path: "reserveListNotify",
        name: "reserveListNotify",
        component: require("@/views/Dashboard/ReserveListNotify.vue").default,
      },
      {
        path: "system",
        name: "system",
        component: require("@/views/Dashboard/System.vue").default,
      },
      {
        path: "quickCheck",
        name: "quickCheck",
        component: require("@/views/Dashboard/QuickCheck.vue").default,
      },
    ],
  },
  {
    path: "/apply",
    component: require("@/views/Apply/Template.vue").default,
    children: [
      {
        name: "apply",
        path: ":id",
        component: require("@/views/Apply/Home.vue").default,
      },
    ],
  },
  {
    path: "/station",
    component: require("@/views/Station/Template.vue").default,
    children: [
      {
        name: "station",
        path: "/",
        component: require("@/views/Station/Home.vue").default,
      },
      {
        path: "scan",
        component: require("@/views/Station/Scan.vue").default,
      },
      {
        path: "pressure-1",
        component: require("@/views/Station/Pressure-1.vue").default,
      },
      {
        path: "pressure-2",
        component: require("@/views/Station/Pressure-2.vue").default,
      },
      {
        path: "body",
        component: require("@/views/Station/Body.vue").default,
      },
      {
        path: "strength",
        component: require("@/views/Station/Strength.vue").default,
      },
      {
        path: "vision",
        component: require("@/views/Station/Vision.vue").default,
      },
      {
        path: "cavity",
        component: require("@/views/Station/Cavity.vue").default,
      },
      {
        path: "final",
        component: require("@/views/Station/Final.vue").default,
      },
      {
        name: "station",
        path: ":id",
        component: require("@/views/Station/Home.vue").default,
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
